<script setup>
const skeletonProductsColumns = ref(6)
const skeletonSuggestionColumns = ref(7)
</script>

<template>
  <div class="grid-standard gap-4 py-8">
    <SkeletonAnimatedPlaceholder
      height="350px"
      width="100%"
      class="col-span-full mb-10 md:col-span-6 md:col-start-4"
    />

    <SkeletonAnimatedPlaceholder
      height="25px"
      width="200px"
      class="col-span-full"
      border-radius="5px"
    />

    <div class="col-span-full mb-10 flex flex-wrap gap-3 md:gap-6 md:px-0">
      <SkeletonAnimatedPlaceholder
        v-for="(item, index) in skeletonSuggestionColumns"
        :key="`suggesiton-column-${index}`"
        height="30px"
        width="100px"
        border-radius="5px"
      />
    </div>

    <div class="grid-container col-span-full gap-8">
      <SkeletonAnimatedPlaceholder
        height="30px"
        width="250px"
        class="col-span-full"
        border-radius="5px"
      />

      <SkeletonAnimatedPlaceholder
        v-for="(item, index) in skeletonProductsColumns"
        :key="`product-column-${index}`"
        width="100%"
        height="270px"
        class="col-span-full md:col-span-2"
        borderRadius="5px"
      />
    </div>
  </div>
</template>
